<template>
	<div>
		<action-sidebar :title="title" :value="true" @close-modal="closeModal">
			<v-layout wrap pa-5>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Nivel" type="number"
						v-model="$v.model.levelOrder.$model" :error="$v.model.levelOrder.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Nombre"
						v-model="$v.model.name.$model" :error="$v.model.name.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select background-color="white" class="body-1 mt-2" box hide-details item-text="description"
						item-value="id" label="Rubro" :items="items" v-model="$v.model.itemId.$model"
						:error="$v.model.itemId.$error"></v-select>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select background-color="white" class="body-1 mt-2" box hide-details item-text="name"
						item-value="id" label="Plan" :items="typePlans" v-model="model.typePlan"
						></v-select>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Icono"
						v-model="model.icon" >
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Color"
						v-model="model.color">
					</v-text-field>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button :is-loading="$v.$invalid || loading" @accept-button-clicked="saveService"
					@cancel-button-clicked="closeModal">
				</modal-sidebar-button>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import { required } from 'vuelidate/lib/validators';

function closeModal() {
	this.goTo('page-levels');
}

async function saveService() {
	const method = this.id ? 'patch' : 'post';
	const url = this.id ? `level/${this.id}` : 'level';
	const message = this.id ? 'modificó' : 'creó';
	try {
		this.model.levelOrder = Number(this.model.levelOrder);
		await this.$http[method](url, this.model, { headers: this.headers });
		this.showNotification(`Se ${message} el nivel correctamente.`);
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function title() {
	const action = 'Nivel';
	return this.id ? `Editar ${action}` : `Nuevo ${action}`;
}

async function loadData() {
	const requests = [this.$http.get(`project/${this.codeProject}/items`), this.$http.get('type-plans', { headers: this.headers })];
	if (this.id) {
		requests.push(this.$http.get(`level/${this.id}`, { headers: this.headers }));
	}
	try {
		const responses = await Promise.all(requests);
		[{ data: { data: this.items } }, { data: { data: this.typePlans } }] = responses;
		this.typePlans.unshift({ id: null, name: 'Sin Plan' });
		if (this.id) {
			[, , { data: this.model }] = responses;
			this.model = this.model.data;
			this.model.codeProject = this.codeProject;
		}
	} catch (error) {
		this.showError();
	}
}

function created() {
	this.loadData();
}

function validations() {
	const validation = {
		model: {
			levelOrder: {
				required,
			},
			itemId: {
				required,
			},
			name: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		domains: [],
		headers: { Accept: `${process.env.ACCEPT_SERVICE_V2}` },
		items: [],
		typePlans: [],
		methods: [
			{ code: 'GET', name: 'GET' },
			{ code: 'POST', name: 'POST' },
			{ code: 'PATCH', name: 'PATCH' },
			{ code: 'PUT', name: 'PUT' },
			{ code: 'DELETE', name: 'DELETE' },
		],
		platforms: [
			{ code: 1, name: 'Web' },
			{ code: 2, name: 'Movil' },
			{ code: 3, name: 'Movil/Web' },
		],
		loading: false,
		model: {
			levelOrder: null,
			itemId: null,
			typePlan: null,
			name: null,
			codeProject: this.codeProject,
			color: null,
			icon: null,
		},
	};
}

export default {
	name: 'page-new-levels',
	data,
	components: {
		actionSidebar,
	},
	created,
	computed: {
		title,
	},
	methods: {
		closeModal,
		loadData,
		saveService,
	},
	props: {
		id: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/pages/levels/page-new-levels.vue